// extracted by mini-css-extract-plugin
export default {"root":"NotificationBlock_root__64WzO","isMobile":"NotificationBlock_isMobile__b7Zy8","counter":"NotificationBlock_counter__pHxOD"};